import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageResponse} from '../../../shared/commons/page-response';
import {SignatureLogPageData} from '../../../../generated-model/models';

/** ค่าตั้งของหน้ารายงาน (จำนวนวันที่เก็บ Log) */
export interface SignLogSettings {
  retentionDays: number;
}

@Injectable({providedIn: 'root'})
export class SignLogService {
  private readonly http = inject(HttpClient);

  search(params: Record<string, string | number>): Observable<PageResponse<SignatureLogPageData>> {
    return this.http.get<PageResponse<SignatureLogPageData>>('/api/sign-log', {params: params as any});
  }

  settings(): Observable<SignLogSettings> {
    return this.http.get<SignLogSettings>('/api/sign-log/settings');
  }
}
